// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"201f61a7","608":"6e10c931"}[chunkId] + ".chunk.js";
};